import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
// import { useStaticQuery, graphql } from "gatsby"

import { NavBar, Footer } from "."
import "./all.sass"

export const Layout = ({ children }) => {
  return (
    <>
      <NavBar />
      <div className="notification is-primary is-light contact-notification">
        <div className="container main-notif">
          <span>
            Liên hệ tư vấn và báo giá: 0983 52 33 62 or nahy@nahytrading.com
          </span>
        </div>
      </div>
      <main>{children}</main>
      <footer>
        <Footer />
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
